<template>
  <div
    ref="promoBarRef"
    v-style:m="{ sm: mobileBlendModeActive ? '0.75rem 0 0 5.5rem' : '0', lg: '0' }"
    class="text-xs p-2 h-8 relative overflow-hidden z-header"
    :class="{
      'bg-black c-white': header.transparent,
      '<lg:fixed <lg:bg-transparent <lg:mix-blend-difference <lg:z-1 <lg:c-white <lg:[mask-image:var(--mi)]': mobileBlendModeActive,
    }"
    :style="mobileBlendModeActive
      ? '--mi: linear-gradient(to right, transparent, black 10%, black 90%, transparent)'
      : ''"
  >
    <base-marquee>
      <template #default="{ cloned }">
        <div v-for="(message, i) in content.messages as Message[]" :key="i" ref="contentRef" class="flex items-center">
          <base-button :tabindex="cloned ? '-1' : undefined" @click="PanelPromoBar.open()">
            <cms-section
              :key="i"
              :section="{ items: [{ ...message, isFullWidth: true }], name: 'promo-bar-message' }"
            />
          </base-button>
          <span aria-hidden="true" class="mx-6 shrink-0">•</span>
        </div>
      </template>
    </base-marquee>
    <panel-promo-bar :content />
  </div>
</template>

<script lang="ts" setup>
import type { Message, PromoBarContent } from '#types/components/cms/promo-bar'

const { content } = defineProps<{ content: PromoBarContent }>()

const route = useRoute()

const contentRef = ref()

const header = useHeaderStore()
const promoBarRef = toRef(header.refs, 'promoBar')

const { headerMobilePromoBlendModeRoutes } = useFeatureFlags()

const mobileBlendModeActive = computed(() =>
  headerMobilePromoBlendModeRoutes.some((pattern) => convertPatternToRegex(pattern).test(route.path)))

const PanelPromoBar = createPanel('promo-bar')
</script>
